import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { Organization } from "../model/Organization";
import { RequestResponse } from "../model/dto/RequestResponse";
import { InvoicementManhattan } from "../model/InvoicementManhattan";

@Injectable()
export class InvoicementDownloadFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string){
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetComboOrgs(): Observable<RequestResponse<Organization[]>> {
        return this._httpClient.get<RequestResponse<Organization[]>>(this._urlBase + 'api/Invoicement/GetOrgs');
    }

    GetInvoicement(initialDate: string, finalDate: string, org: string): Observable<RequestResponse<InvoicementManhattan[]>> {
        let params = new HttpParams();
        params = params.append('initialDate', initialDate);
        params = params.append('finalDate', finalDate);
        params = params.append('org', org);

        return this._httpClient.get<RequestResponse<InvoicementManhattan[]>>(this._urlBase + 'api/Invoicement/GetInvoicement', { params: params });
    }
}